module.exports = __webpack_public_path__ + "static/media/blog6_sm.35145d39.webp";